import type { IActionDefinitionDto } from "@kuika/kuika-cl-model";

/**
 * Action definitions by id, for the action pickers' preview and row glyphs. The index is rebuilt only
 * when the catalogue array itself is replaced (a new load), so looking up every row a popup paints
 * stays O(1) without a stale entry surviving a reload.
 */
export class ActionDefinitionLookup {
  private source: IActionDefinitionDto[] | null = null;

  private byId: Map<string, IActionDefinitionDto> = new Map<string, IActionDefinitionDto>();

  get(definitions: IActionDefinitionDto[] | undefined, id: string): IActionDefinitionDto | undefined {
    const current: IActionDefinitionDto[] = definitions ?? [];
    if (this.source !== current) {
      this.source = current;
      this.byId = new Map<string, IActionDefinitionDto>(
        current.map((definition: IActionDefinitionDto): [string, IActionDefinitionDto] => [definition.id, definition])
      );
    }
    return this.byId.get(id);
  }
}
